import { render, staticRenderFns } from "./ProviderPreauths.vue?vue&type=template&id=21516fe3&scoped=true&"
import script from "./ProviderPreauths.vue?vue&type=script&lang=js&"
export * from "./ProviderPreauths.vue?vue&type=script&lang=js&"
import style0 from "./ProviderPreauths.vue?vue&type=style&index=0&id=21516fe3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21516fe3",
  null
  
)

export default component.exports